import React from 'react';
import PropTypes from 'prop-types';
import { RECIPIENT_OPTIONS, RECIPIENT_TYPES } from './recipientsModel';

// Сегментированный контрол выбора получателя (.bc-seg).
export default function RecipientSegment({ value, onChange, smenaCount }) {
    return (
        <div className="bc-seg">
            {RECIPIENT_OPTIONS.map(({ type, label, Icon, showCount }) => (
                <button
                    type="button"
                    key={type}
                    className={`opt${value === type ? ' on' : ''}`}
                    onClick={() => onChange(type)}
                >
                    <Icon />
                    {showCount ? `${label} (${smenaCount})` : label}
                </button>
            ))}
        </div>
    );
}

RecipientSegment.propTypes = {
    value: PropTypes.oneOf(Object.values(RECIPIENT_TYPES)).isRequired,
    onChange: PropTypes.func.isRequired,
    smenaCount: PropTypes.number.isRequired
};
